var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _mask, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayoutHalfProgressIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.9446,
    cy: 31.9446,
    r: 31.9446,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.292 44.3962H24.7087C20.3337 44.3962 17.417 42.2087 17.417 37.1045V26.8962C17.417 21.792 20.3337 19.6045 24.7087 19.6045H39.292C43.667 19.6045 46.5837 21.792 46.5837 26.8962V37.1045C46.5837 42.2087 43.667 44.3962 39.292 44.3962Z",
    stroke: "#1E247E",
    strokeWidth: 2.16,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36.375C34.4162 36.375 36.375 34.4162 36.375 32C36.375 29.5838 34.4162 27.625 32 27.625C29.5838 27.625 27.625 29.5838 27.625 32C27.625 34.4162 29.5838 36.375 32 36.375Z",
    fill: "#DA867D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.417 27.6247H18.8753C23.2503 27.6247 24.7087 26.1663 24.7087 21.7913V20.333",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5837 27.6247H45.1253C40.7503 27.6247 39.292 26.1663 39.292 21.7913V20.333",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.417 36.375H18.8753C23.2503 36.375 24.7087 37.8333 24.7087 42.2083V43.6667",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5837 36.375H45.1253C40.7503 36.375 39.292 37.8333 39.292 42.2083V43.6667",
    stroke: "#1E247E",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34C33.1046 34 34 33.1046 34 32C34 30.8954 33.1046 30 32 30C30.8954 30 30 30.8954 30 32C30 33.1046 30.8954 34 32 34Z",
    fill: "#F0C330"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-1_27535_35779",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0555 0.0551531C36.2505 0.0624405 40.403 0.895926 44.2759 2.50802C48.1488 4.12011 51.6662 6.47925 54.6274 9.45072C57.5886 12.4222 59.9355 15.9478 61.5341 19.8263C63.1327 23.7048 63.9518 27.8601 63.9445 32.0552C63.9372 36.2502 63.1037 40.4027 61.4916 44.2756C59.8795 48.1485 57.5204 51.6659 54.5489 54.6271C51.5775 57.5882 48.0518 59.9351 44.1734 61.5338C40.2949 63.1324 36.1395 63.9515 31.9445 63.9442L31.9483 61.7316C35.8528 61.7384 39.7204 60.9761 43.3302 59.4882C46.94 58.0003 50.2215 55.8159 52.9871 53.0598C55.7528 50.3038 57.9485 47.03 59.449 43.4253C60.9494 39.8207 61.7252 35.9558 61.732 32.0513C61.7387 28.1469 60.9764 24.2793 59.4885 20.6694C58.0006 17.0596 55.8163 13.7782 53.0602 11.0125C50.3041 8.24685 47.0303 6.05112 43.4256 4.55068C39.821 3.05024 35.9561 2.27449 32.0516 2.2677L32.0555 0.0551531Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0555 0.0551531C36.2505 0.0624405 40.403 0.895926 44.2759 2.50802C48.1488 4.12011 51.6662 6.47925 54.6274 9.45072C57.5886 12.4222 59.9355 15.9478 61.5341 19.8263C63.1327 23.7048 63.9518 27.8601 63.9445 32.0552C63.9372 36.2502 63.1037 40.4027 61.4916 44.2756C59.8795 48.1485 57.5204 51.6659 54.5489 54.6271C51.5775 57.5882 48.0518 59.9351 44.1734 61.5338C40.2949 63.1324 36.1395 63.9515 31.9445 63.9442L31.9483 61.7316C35.8528 61.7384 39.7204 60.9761 43.3302 59.4882C46.94 58.0003 50.2215 55.8159 52.9871 53.0598C55.7528 50.3038 57.9485 47.03 59.449 43.4253C60.9494 39.8207 61.7252 35.9558 61.732 32.0513C61.7387 28.1469 60.9764 24.2793 59.4885 20.6694C58.0006 17.0596 55.8163 13.7782 53.0602 11.0125C50.3041 8.24685 47.0303 6.05112 43.4256 4.55068C39.821 3.05024 35.9561 2.27449 32.0516 2.2677L32.0555 0.0551531Z",
    stroke: "#3876BB",
    strokeWidth: 8,
    mask: "url(#path-9-inside-1_27535_35779)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayoutHalfProgressIcon);
export default __webpack_public_path__ + "static/media/PayoutHalfProgressIcon.98a4a736413e239960becf1d7f841113.svg";
export { ForwardRef as ReactComponent };